import { useState, useEffect } from 'react';

const useAppInstall = (): boolean => {
  const [isAppInstall, setIsAppInstall] = useState(false);

  useEffect(() => {
    const checkApp = async (): Promise<void> => {
      try {
        if (navigator && navigator.getInstalledRelatedApps) {
          // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
          const relatedApps: any[] = await navigator.getInstalledRelatedApps();
          if (relatedApps?.length > 0) {
            setIsAppInstall(true);
          }
        }
      } catch (error) {
        console.error(`Error ${error}`);
      }
    };
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    checkApp();
  }, []);

  return isAppInstall;
};

export default useAppInstall;
